export default class InitSearchFields {

	constructor (context) {
		this.context = context;

		this.fireEvent(window, 'mmsearchfield_override');

		var lookup			= {};
		var elements		= document.querySelectorAll('[data-mm_searchfield_id]');

		for (var i = 0, i_len = elements.length; i < i_len; i++) {
			var searchfieldid = elements[i].getAttribute('data-mm_searchfield_id');
			if (searchfieldid) {
				if (!lookup[searchfieldid]) {
					lookup[searchfieldid] = {};
				}

				if (elements[i].getAttribute('data-mm_searchfield')) {
					lookup[searchfieldid].element_search = elements[i];
				} else if (elements[i].getAttribute('data-mm_searchfield_menu')) {
					lookup[searchfieldid].element_menu = elements[i];
				}
			}
		}

		for (var id in lookup) {
			if (!lookup.hasOwnProperty(id)					||
				!lookup[id].element_search					||
				!lookup[id].element_menu					||
				lookup[id].element_search.nodeType !== 1 	||
				lookup[id].element_menu.nodeType !== 1 		||
				lookup[id].element_search.nodeName.toLowerCase() !== 'input') {
				continue;
			}

			this.searchFieldListen(lookup[id].element_search, lookup[id].element_menu);
		}
	}

	searchFieldListen (element_search, element_menu) {
		const self = this;

		element_search.addEventListener('focus', function searchFieldInit () {
			self.searchFieldInit(element_search, element_menu);

			element_search.removeEventListener('focus', searchFieldInit, false);
		}, false);
	}

	async searchFieldInit (element_search, element_menu) {
		const {default: SearchField} = await import('./searchField');

		new SearchField(this.context, element_search, element_menu);

		this.fireEvent(window, 'mmsearchfield_initialized');
	}

	fireEvent (obj, eventType) {
		try {
			var e = new Event(eventType, {
				bubbles: true,
				cancelable: true
			});

			obj.dispatchEvent(e);
		} catch (error) {

			/*
			 *
			 * Internet Explorer fallback. Requires window to be the dispatcher
			 *
			 */

			var ief = document.createEvent('HTMLEvents');
			ief.initEvent(eventType, true, true);
			ief.eventName	= eventType;
			window.dispatchEvent(ief);
		}
	}
}

